// extracted by mini-css-extract-plugin
module.exports = {"delContainer":"Delivery_delContainer__V_RcQ"};